/* Burcu Pan — Stilpass-Reader (window.PPStilpass)
   Liest den Stilpass aus localStorage (pp_stilpass_v1) und stellt die
   gemeinsamen Namens-/Slug-Maps bereit. Genutzt von pp-stilpass-box.liquid
   und den fünf Figurtyp-Guides. ES5, keine Abhängigkeiten, rein lesend. */
(function () {
  'use strict';

  var KEY = 'pp_stilpass_v1';

  var SIL_NAME = { sanduhr: 'Sanduhr', dreieck: 'Dreieck', vdreieck: 'Umgekehrtes Dreieck', rechteck: 'Rechteck', rund: 'Rund' };
  var SIL_SLUG = { sanduhr: 'figurtyp-sanduhr', dreieck: 'figurtyp-dreieck', vdreieck: 'figurtyp-umgekehrtes-dreieck', rechteck: 'figurtyp-rechteck', rund: 'figurtyp-rund' };
  var COLL = { sanduhr: 'sanduhr', dreieck: 'dreieck', vdreieck: 'umgekehrtes-dreieck', rechteck: 'rechteck', rund: 'rund' };
  var FARBE_NAME = { fruehling: 'Frühling · warm & hell', sommer: 'Sommer · kühl & weich', herbst: 'Herbst · warm & tief', winter: 'Winter · kühl & klar', neutral: 'Zwischen den Welten' };
  var FARBE_KURZ = { fruehling: 'Frühlingstöne', sommer: 'Sommertöne', herbst: 'Herbsttöne', winter: 'Wintertöne', neutral: 'Mitteltöne' };
  var STIL_NAME = { kla: 'Die Klassische', nat: 'Die Natürliche', rom: 'Die Romantische', min: 'Die Minimalistin', aus: 'Die Ausdrucksstarke' };

  /* Nur für die Namensformel: */
  var ADJ = { kla: 'klassische', nat: 'natürliche', rom: 'romantische', min: 'minimalistische', aus: 'ausdrucksstarke' };
  var SIL_KURZ = { sanduhr: 'Sanduhr', dreieck: 'Dreieck', vdreieck: 'V', rechteck: 'Rechteck', rund: 'Rund' };
  var FARBE_ANHANG = { fruehling: 'in frischen Frühlingstönen', sommer: 'in weichen Sommertönen', herbst: 'in warmen Herbsttönen', winter: 'in klaren Wintertönen', neutral: 'in gedeckten Mitteltönen' };

  function buildName(fig, farbe, stil) {
    var figTyp = fig && SIL_KURZ[fig.typ] ? fig.typ : null;
    var stilPrim = stil && ADJ[stil.prim] ? stil.prim : null;
    var welt = farbe && FARBE_ANHANG[farbe.welt] ? farbe.welt : null;
    var name = '';
    if (figTyp && stilPrim) name = 'Die ' + ADJ[stilPrim] + ' ' + SIL_KURZ[figTyp] + '-Silhouette';
    else if (figTyp) name = 'Deine ' + SIL_KURZ[figTyp] + '-Silhouette';
    else if (stilPrim) name = STIL_NAME[stilPrim];
    if (name && welt) name += ' ' + FARBE_ANHANG[welt];
    if (!name && welt) name = FARBE_NAME[welt];
    return name;
  }

  function read() {
    var raw, d;
    try {
      raw = window.localStorage.getItem(KEY);
    } catch (e) {
      return { ok: false };
    }
    if (!raw) return { ok: false };
    try {
      d = JSON.parse(raw);
    } catch (e2) {
      return { ok: false };
    }
    if (!d || d.v !== 1 || !d.res || typeof d.res !== 'object') return { ok: false };
    var res = d.res;
    var out = { ok: true, name: '', ts: typeof d.ts === 'string' ? d.ts : '' };
    if (res.fig && typeof res.fig === 'object' && SIL_NAME[res.fig.typ]) out.fig = res.fig;
    if (res.farbe && typeof res.farbe === 'object' && FARBE_NAME[res.farbe.welt]) out.farbe = res.farbe;
    if (res.stil && typeof res.stil === 'object' && STIL_NAME[res.stil.prim]) out.stil = res.stil;
    if (res.leben && typeof res.leben === 'object') out.leben = res.leben;
    if (!out.fig && !out.farbe && !out.stil && !out.leben) return { ok: false };
    out.name = buildName(out.fig, out.farbe, out.stil);
    return out;
  }

  window.PPStilpass = {
    read: read,
    SIL_NAME: SIL_NAME,
    SIL_SLUG: SIL_SLUG,
    COLL: COLL,
    FARBE_NAME: FARBE_NAME,
    FARBE_KURZ: FARBE_KURZ,
    STIL_NAME: STIL_NAME
  };
})();
